var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 229,
    viewBox: "0 0 215 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.447 119.895C195.692 77.0003 154.617 47.8331 110.703 54.7487C66.7889 61.6643 36.6659 102.044 43.421 144.939C50.1762 187.834 91.2515 217.001 135.165 210.086C179.079 203.17 209.202 162.791 202.447 119.895Z",
    fill: "#008894"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5400_14516",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 27,
    width: 162,
    height: 158
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9211 27.1845C47.4936 27.139 11.1806 62.3246 10.8136 105.774C10.4467 149.223 46.1647 184.482 90.5922 184.527C135.02 184.573 171.333 149.387 171.7 105.938C172.067 62.4891 136.349 27.2299 91.9211 27.1845Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5400_14516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8203 210.721C23.1667 200.22 32.9259 198.683 31.2723 188.183C29.619 177.685 19.8599 179.222 18.2063 168.722C16.5526 158.221 26.3122 156.687 24.6586 146.186C23.0054 135.688 13.2462 137.225 11.5926 126.725C9.93859 116.222 19.6978 114.685 18.0442 104.185C16.3898 93.6797 6.63063 95.2166 4.97627 84.7114C3.32229 74.2087 13.0815 72.6718 11.4279 62.1714C9.77275 51.6615 0.0135695 53.1984 -1.64154 42.6885C-3.29665 32.1785 6.46254 30.6417 4.8078 20.1341",
    stroke: "#2B2A7B",
    strokeWidth: 8.53457,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.541 207.297C44.8874 196.796 54.6466 195.26 52.993 184.759C51.3398 174.261 41.5806 175.798 39.927 165.298C38.2734 154.797 48.0329 153.263 46.3793 142.762C44.7261 132.264 34.9669 133.801 33.3133 123.301C31.6593 112.798 41.4185 111.261 39.7649 100.761C38.1105 90.2558 28.3513 91.7927 26.697 81.2876C25.043 70.7848 34.8022 69.2479 33.1486 58.7476C31.4935 48.2377 21.7343 49.7745 20.0792 39.2646C18.4241 28.7547 28.1832 27.2178 26.5285 16.7103",
    stroke: "#2B2A7B",
    strokeWidth: 8.53457,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2773 203.881C66.6237 193.38 76.3829 191.844 74.7293 181.343C73.0761 170.845 63.3169 172.382 61.6633 161.882C60.0097 151.381 69.7692 149.847 68.1156 139.346C66.4624 128.848 56.7032 130.385 55.0496 119.885C53.3956 109.382 63.1548 107.845 61.5012 97.345C59.8468 86.8398 50.0877 88.3767 48.4333 77.8716C46.7793 67.3688 56.5385 65.8319 54.8849 55.3316C53.2298 44.8216 43.4706 46.3585 41.8155 35.8486C40.1604 25.3387 49.9196 23.8018 48.2648 13.2943",
    stroke: "#2B2A7B",
    strokeWidth: 8.53457,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9941 200.453C88.3405 189.953 98.0997 188.416 96.4461 177.915C94.7929 167.417 85.0337 168.954 83.3801 158.454C81.7265 147.954 91.486 146.419 89.8324 135.919C88.1792 125.421 78.42 126.958 76.7664 116.457C75.1124 105.955 84.8716 104.418 83.218 93.9172C81.5636 83.4121 71.8045 84.949 70.1501 74.4438C68.4961 63.9411 78.2553 62.4042 76.6017 51.9038C74.9466 41.3939 65.1874 42.9308 63.5323 32.4209C61.8772 21.911 71.6364 20.3741 69.9816 9.86655",
    stroke: "#2B2A7B",
    strokeWidth: 8.53457,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.729 197.039C110.075 186.539 119.834 185.002 118.18 174.501C116.527 164.003 106.768 165.54 105.114 155.04C103.461 144.54 113.22 143.005 111.567 132.505C109.914 122.007 100.154 123.544 98.5008 113.043C96.8468 102.54 106.606 101.004 104.952 90.5032C103.298 79.998 93.5388 81.5349 91.8845 71.0298C90.2305 60.527 99.9897 58.9901 98.3361 48.4898C96.681 37.9798 86.9218 39.5167 85.2667 29.0068C83.6116 18.4969 93.3707 16.96 91.716 6.45249",
    stroke: "#2B2A7B",
    strokeWidth: 8.53457,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.465 193.604C131.811 183.103 141.57 181.566 139.917 171.066C138.264 160.568 128.504 162.105 126.851 151.604C125.197 141.104 134.957 139.57 133.303 129.069C131.65 118.571 121.891 120.108 120.237 109.608C118.583 99.1049 128.342 97.568 126.689 87.0676C125.034 76.5625 115.275 78.0994 113.621 67.5942C111.967 57.0915 121.726 55.5546 120.072 45.0542C118.417 34.5443 108.658 36.0812 107.003 25.5713C105.348 15.0614 115.107 13.5245 113.452 3.01694",
    stroke: "#2B2A7B",
    strokeWidth: 8.53457,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.188 190.189C153.534 179.689 163.293 178.152 161.639 167.652C159.986 157.154 150.227 158.691 148.573 148.19C146.92 137.69 156.679 136.155 155.026 125.655C153.373 115.157 143.613 116.694 141.96 106.194C140.306 95.6908 150.065 94.1539 148.411 83.6536C146.757 73.1484 136.998 74.6853 135.343 64.1802C133.689 53.6774 143.449 52.1405 141.795 41.6401C140.14 31.1302 130.381 32.6671 128.726 22.1572C127.071 11.6473 136.83 10.1104 135.175 -0.397119",
    stroke: "#2B2A7B",
    strokeWidth: 8.53457,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.908 186.771C175.255 176.271 185.014 174.734 183.36 164.234C181.707 153.736 171.948 155.273 170.294 144.772C168.641 134.272 178.4 132.737 176.746 122.237C175.093 111.739 165.334 113.276 163.68 102.776C162.026 92.2729 171.786 90.736 170.132 80.2356C168.478 69.7305 158.719 71.2673 157.064 60.7622C155.41 50.2594 165.169 48.7226 163.516 38.2222C161.861 27.7123 152.101 29.2491 150.446 18.7392C148.791 8.22932 158.55 6.69244 156.896 -3.81509",
    stroke: "#2B2A7B",
    strokeWidth: 8.53457,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLeft);
export default __webpack_public_path__ + "static/media/top-left.11f9a1bedf6c74367c0b4dfe7dbd96d3.svg";
export { ForwardRef as ReactComponent };